import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { isNativeFeatureEnabled } from 'mini-host-bridge/lib/utils/isNativeFeatureEnabled';

export const isMultiAccountPopupEnabled = () =>
    isNativeFeatureEnabled('multi-account') && isMiniHostAppFeatureEnabled('multiAccount');
